/**
 * @fileoverview Category gradient lookup for the Loci HappeningCard.
 *
 * Maps a canonical category key (lowercase) to a linear-gradient CSS value.
 * Gradients are expressed in terms of the `--loci-color-category-*` tokens so
 * they flip automatically between light and dark themes. An `unknown` fallback
 * is used when a category is missing or not recognised.
 */
const CATEGORY_GRADIENTS = {
    music: 'linear-gradient(135deg, var(--loci-color-category-music-primary) 0%, var(--loci-color-category-music-dark) 100%)',
    sports: 'linear-gradient(135deg, var(--loci-color-category-sports-primary) 0%, var(--loci-color-category-sports-dark) 100%)',
    food: 'linear-gradient(135deg, var(--loci-color-category-food-primary) 0%, var(--loci-color-category-food-dark) 100%)',
    tech: 'linear-gradient(135deg, var(--loci-color-category-tech-primary) 0%, var(--loci-color-category-tech-dark) 100%)',
    art: 'linear-gradient(135deg, var(--loci-color-category-art-primary) 0%, var(--loci-color-category-art-dark) 100%)',
    drinks: 'linear-gradient(135deg, var(--loci-color-category-drinks-primary) 0%, var(--loci-color-category-drinks-dark) 100%)',
    unknown: 'linear-gradient(135deg, var(--loci-color-secondary) 0%, var(--loci-color-surface-alt) 100%)',
};
const CATEGORY_ALIASES = {
    music: 'music',
    concert: 'music',
    concerts: 'music',
    sport: 'sports',
    sports: 'sports',
    food: 'food',
    'food-drink': 'food',
    dining: 'food',
    tech: 'tech',
    technology: 'tech',
    art: 'art',
    arts: 'art',
    theater: 'art',
    theatre: 'art',
    drink: 'drinks',
    drinks: 'drinks',
    nightlife: 'drinks',
};
/** Normalise an input category label (case / synonym insensitive). */
export function resolveHappeningCardCategory(category) {
    if (!category)
        return 'unknown';
    const key = category.trim().toLowerCase();
    return CATEGORY_ALIASES[key] ?? 'unknown';
}
/**
 * Return the gradient CSS value for a category label.
 *
 * @param category — Free-form category label (e.g. `"Music"`, `"food-drink"`).
 *                   Unknown values fall back to a neutral indigo gradient.
 */
export function getCategoryGradient(category) {
    return CATEGORY_GRADIENTS[resolveHappeningCardCategory(category)];
}
